<div class="container-fluid">
  <form #f="ngForm" (ngSubmit)="addReceipe()">
    <div class="row">



      <div class="col-lg-12">
        <div class="iq-card">
          <div class="iq-card-header d-flex justify-content-between">
            <div class="iq-header-title">
              <h4 class="card-title">New Recipe Information</h4>
            </div>
          </div>
          <div class="iq-card-body">
            <div class="new-user-info">
              <div class="row">

                <div class="form-group col-md-12">
                  <div class="form-group col-md-12"><label for="fname"><strong>Diet Tags</strong><span
                        class="color">*</span>:</label></div>
                  <div class="col-2 floatLeft" *ngFor="let dietTag of tags.dietTags;">
                    <label class="radio-inline">
                      <input type="checkbox" name="optradio" (change)="selectedTags($event,dietTag.tagName,1)"
                        style="padding-left:25px;"><span style="padding-left:6px;">{{dietTag.tagName}}</span>
                    </label>
                  </div>
                </div>

                <div class="form-group col-md-12">
                  <div class="form-group col-md-12"><label for="fname"><strong>Allergy Tags</strong><span
                        class="color">*</span>:</label></div>
                  <div class="col-2 floatLeft" *ngFor="let Allgtag of tags.allergyTags;">
                    <label class="radio-inline">
                      <input type="checkbox" name="optradio" (change)="selectedTags($event,Allgtag.tagName,2)"
                        style="padding-left:25px;"><span style="padding-left:6px;">{{Allgtag.tagName}}</span>
                    </label>
                  </div>

                </div>
                <div class="form-group col-md-12">
                  <button style="margin-left:10px" type="button" class="btn btn-success" (click)="addNewTag()">Add New
                    Tag</button>
                </div>
                <!-- <div class="form-group col-md-12">
                           <label for="lname">Recipe Tags ( write tag and press enter)<span class="color">*</span>:</label>
                           <tag-input placeholder="write tag and press enter" [(ngModel)]="receipe.tags" 
                           [ngModelOptions]="{standalone: true}" (onSelect)="onSelect($event)" [editable]="true" 
                                         (onTagEdited)="onTagEdited($event)" (onAdd)="onAdd($event)" (onRemove)="onRemove($event)"
                                         [modelAsStrings]="true">
                              </tag-input>
                        </div>
                      -->
                <div class="form-group col-md-6">
                  <label for="fname"><strong>Recipe Name</strong><span class="color">*</span>:</label>
                  <input type="text" pInputText [(ngModel)]="receipe.recipeName" [ngModelOptions]="{standalone: true}"
                    required class="form-control" id="fname" placeholder="Recipe Name">
                </div>

                <div class="form-group col-md-6">
                  <label for="fname"><strong>Recipe Type</strong>:</label>
                  <select class="form-control" [(ngModel)]="receipe.recipeType" [ngModelOptions]="{standalone: true}">
                    <option value="">Choose Type</option>
                    <option value="main_dishes">Main Dishes</option>
                    <option value="soup">Soup</option>
                    <option value="salad">Salad</option>
                    <option value="smoothie">Smoothies</option>
                    <option value="snack">Snacks</option>
                    <option value="beverages">Beverages</option>
                    <option value="fruit">Fruits</option>
                    <option value="vegetables">Vegetables</option>
                    <option value="miscellaneous">Miscellaneous</option>
                  </select>
                </div>

                <div class="form-group col-md-6">
                  <label for="fname"><strong>Evaporation</strong><span class="color">*</span>:</label>
                  <input type="text" pInputText [(ngModel)]="receipe.evaporate" [ngModelOptions]="{standalone: true}"
                    required class="form-control" id="fname" placeholder="Evaporation">
                </div>

                <div class="form-group col-md-12">
                  <label for="lname"><strong>Ingredients:</strong> &nbsp; &nbsp; <button style="margin-left:10px"
                      type="button" class="btn btn-success" (click)="addNewIngredientForm()">Add New
                      Ingredient</button></label>
                </div>
                <div class="form-group col-md-12">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Ingredients</th>
                        <th style="min-width: 170px;">Measure</th>
                        <th>Qty</th>
                        <th>Cals</th>
                        <th>Protien</th>
                        <th>Carbs</th>
                        <th>Fat</th>
                        <th>Action</th>

                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let row of rows;let i = index">
                        <td>{{i+1}}</td>
                        <td><input type="text" [(ngModel)]="row.ingredientName" (keyup)="searchIngredent($event,i)"
                            [ngModelOptions]="{standalone: true}" placeholder="Ingredients" class="form-control" />
                          <input type="hidden" [(ngModel)]="row.ingredientId" [ngModelOptions]="{standalone: true}" />
                          <div *ngIf="rows[i].isSearchBoxShow" class="col-md-2 searchBox">
                            <span *ngIf="showPleaseText">{{searchTextMessage}}</span>
                            <ul>
                              <li *ngFor="let Ingre of rows[i]['searchIngredents'];let j = index"><a
                                  (click)="selectedIngredent(Ingre.ingredientTitle,Ingre.id,i,Ingre)"
                                  href="javascript:void(0)">{{Ingre.ingredientTitle}}</a></li>
                            </ul>
                          </div>
                        </td>
                        <td>
                          <select [(ngModel)]="row.measure" class="form-control" (change)="addUnit($event,i,1)"
                            [ngModelOptions]="{standalone: true}">
                            <option [ngValue]="null" disabled>Choose Measure</option>
                            <option *ngFor="let measureType of row.measurement" [ngValue]="measureType">
                              {{ measureType }}({{ row.measureunit[measureType] }} {{ measureUnit }})
                            </option>

                          </select>
                        </td>
                        <td class="fixedWidth"><input pinputtext pKeyFilter="int" (keyup)="addUnit($event,i,2)"
                            [(ngModel)]="row.qty" [ngModelOptions]="{standalone: true}" class="form-control"
                            class="form-control serveInput" placeholder="Qty">

                        </td>

                        <td class="fixedWidth"><input pinputtext pKeyFilter="int" class="form-control"
                            [(ngModel)]="row.cals" [ngModelOptions]="{standalone: true}" class="form-control serveInput"
                            placeholder="Cals"></td>
                        <td class="fixedWidth"><input pinputtext pKeyFilter="int" class="form-control"
                            [(ngModel)]="row.protien" [ngModelOptions]="{standalone: true}"
                            class="form-control serveInput" placeholder="Protien"></td>
                        <td class="fixedWidth"><input pinputtext pKeyFilter="int" class="form-control"
                            [(ngModel)]="row.carbs" [ngModelOptions]="{standalone: true}"
                            class="form-control serveInput" placeholder="Carbs"></td>
                        <td class="fixedWidth"><input pinputtext pKeyFilter="int" class="form-control"
                            [(ngModel)]="row.fat" [ngModelOptions]="{standalone: true}" class="form-control serveInput"
                            placeholder="Fat"></td>

                        <td><button style="margin-left:10px" class="btn btn-danger"
                            (click)="deleteRow(i)">Remove</button></td>
                      </tr>
                      <tr>
                        <td></td>
                        <td>Total</td>
                        <td></td>
                        <td></td>
                        <td>{{this.receipe.totalCals}}</td>
                        <td>{{this.receipe.totalProtien}}</td>
                        <td>{{this.receipe.totalCarbs}}</td>
                        <td>{{this.receipe.totalFats}}</td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                  <button type="button" style="margin-left:10px" class="btn btn-success" (click)="addRow()">Add
                    Row</button>
                </div>





                <div class="form-group col-md-12">
                  <label for="lname"><strong>Ingredients Description:</strong></label>
                  <angular-editor [placeholder]="'Enter text here...'" [(ngModel)]="receipe.shortDescription"
                    [ngModelOptions]="{standalone: true}"></angular-editor>
                </div>

                <div class="form-group col-md-6">
                  <div class="form-group col-md-12">
                    <label for="fname"><strong>Recipe Image:</strong></label>
                  </div>
                  <div class="form-group col-md-12">
                    <input type="file" (change)="onFilechange($event)"
                    id="fname"
                    placeholder="Reference Link"
                    />
                  </div>

                </div>


                <div class="form-group col-md-6">
                  <div class="form-group col-md-12">
                    <label for="fname"><strong>Reference Link:</strong></label>
                  </div>
                  <div class="form-group col-md-12">
                    <input type="text" pInputText [(ngModel)]="receipe.referenceLink"
                      [ngModelOptions]="{standalone: true}" class="form-control" id="fname"
                      placeholder="Reference Link">
                  </div>
                </div>

                <div class="form-group col-md-12">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Preparation Step</th>
                        <th>Description</th>

                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let row of rowStep;let i = index">
                        <td>Step {{i+1}}</td>

                        <!-- <td class="stepClass"><input  [(ngModel)]="row.step" [ngModelOptions]="{standalone: true}" class="form-control" class="form-control serveInput"  placeholder="Step">
                                    
                                    </td> -->

                        <td class="descriptionClass"><input class="form-control" [(ngModel)]="row.description"
                            [ngModelOptions]="{standalone: true}" class="form-control serveInput"
                            placeholder="Description"></td>


                        <td><button type="button" style="margin-left:10px" class="btn btn-danger"
                            (click)="deleteRowStep(i)">Remove</button></td>
                      </tr>
                    </tbody>
                  </table>
                  <button type="button" style="margin-left:10px" class="btn btn-success" (click)="addStepRow()">Add
                    Row</button>
                </div>


                <div class="form-group col-md-12">
                  <label for="fname"><strong>Note:</strong></label>

                  <textarea [(ngModel)]="receipe.note" [ngModelOptions]="{standalone: true}" class="form-control"
                    id="fname" placeholder="Note"></textarea>
                </div>

              </div>



              <button type="submit" class="btn btn-primary">Add Receipe</button>

            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<p-dialog header="Add New Tag" [(visible)]="visibleTag" [style]="{width: '50vw'}">
  <form #f="ngForm" (ngSubmit)="addNewTags()">
    <div class="row">
      <div class="form-group col-md-6">
        <label for="lname">Tag Name<span class="color">*</span>:</label>
        <input class="form-control" [(ngModel)]="tagName" [ngModelOptions]="{standalone: true}" type="text"
          placeholder="Tag Name" />
      </div>
      <div class="form-group col-md-6">
        <label for="lname">Tag Type<span class="color">*</span>:</label>
        <select class="form-control" [(ngModel)]="tagType" [ngModelOptions]="{standalone: true}">
          <option value="">Choose Option</option>
          <option value="1">Diets</option>
          <option value="2">Allergies</option>
        </select>
      </div>
    </div>

    <div class="form-group col-md-12">
      <button type="submit" class="btn btn-primary">Add Tag</button>
    </div>

  </form>
</p-dialog>

<p-dialog header="Add New Ingredient" [(visible)]="visible" [style]="{width: '50vw'}">
  <div class="table-responsive">
    <form #f="ngForm" (ngSubmit)="addNewIngredient()">
      <div class="row">

        <div class="form-group col-md-6">
          <label for="lname">Ingredient Name<span class="color">*</span>:</label>
          <input class="form-control" [(ngModel)]="ingredient.ingredientTitle" [ngModelOptions]="{standalone: true}"
            type="text" placeholder="Ingredient Name" />
        </div>
        <div class="form-group col-md-6">
          <label for="lname">Ingredient Type<span class="color">*</span>:</label>
          <select class="form-control" [(ngModel)]="ingredient.ingredientType" [ngModelOptions]="{standalone: true}">
            <option value="">Choose Option</option>
            <option value="Liquid">Liquid</option>
            <option value="Solid">Solid</option>
            <option value="Semisolid">Semi-Solid</option>
            <option value="Semiliquid">Semi-Liquid</option>
            <option value="Oil">Oil</option>
            <option value="Meat">Meat</option>
            <option value="Egg">Egg</option>
            <option value="Solid">Small Piece</option>
            <option value="Solid">Medium Piece</option>
            <option value="Solid">Large Piece</option>
          </select>
        </div>
        <div class="form-group col-md-12">
          <label for="lname">Ingredient Description:</label>
          <textarea class="form-control" [(ngModel)]="ingredient.ingredientDescription"
            [ngModelOptions]="{standalone: true}" placeholder="Ingredient Name"></textarea>
        </div>
        <hr>
        <div class="form-group col-md-12 "> Note : Ingredient Value Per 100gm</div>


        <div class="form-group col-md-2 ">
          <label for="lname">Cals:</label>
          <div class="input-group">
            <input class="form-control" pinputtext pKeyFilter="money" [(ngModel)]="ingredient.cals.value"
              [ngModelOptions]="{standalone: true}" type="text" placeholder="Cals" />
            <span class="input-group-addon">Kcal</span>
          </div>

        </div>
        <div class="form-group col-md-2">
          <label for="lname">Protien:</label>
          <div class="input-group">
            <input class="form-control" pinputtext pKeyFilter="money" [(ngModel)]="ingredient.protien.value"
              [ngModelOptions]="{standalone: true}" type="text" placeholder="Protien" />
            <span class="input-group-addon">g</span>
          </div>
        </div>
        <div class="form-group col-md-2">
          <label for="lname">Fats:</label>
          <div class="input-group">
            <input class="form-control" pinputtext pKeyFilter="money" [(ngModel)]="ingredient.fats.value"
              [ngModelOptions]="{standalone: true}" type="text" placeholder="Fats" />
            <span class="input-group-addon">g</span>
          </div>
        </div>
        <div class="form-group col-md-2">
          <label for="lname">Carbs:</label>
          <div class="input-group">
            <input class="form-control" pinputtext pKeyFilter="money" [(ngModel)]="ingredient.carbs.value"
              [ngModelOptions]="{standalone: true}" type="text" placeholder="Carbs" />
            <span class="input-group-addon">g</span>
          </div>
        </div>
        <div class="form-group col-md-2">
          <label for="lname">Fiber:</label>
          <div class="input-group">
            <input class="form-control" pinputtext pKeyFilter="money" [(ngModel)]="ingredient.fibre.value"
              [ngModelOptions]="{standalone: true}" type="text" placeholder="Fiber" />
            <span class="input-group-addon">g</span>
          </div>
        </div>
        <div class="form-group col-md-2">
          <label for="lname">Calcium:</label>
          <div class="input-group">
            <input class="form-control" pinputtext pKeyFilter="money" [(ngModel)]="ingredient.calcium.value"
              [ngModelOptions]="{standalone: true}" type="text" placeholder="Fiber" />
            <span class="input-group-addon">mg</span>
          </div>
        </div>
        <div class="form-group col-md-2">
          <label for="lname">Iron:</label>
          <div class="input-group">
            <input class="form-control" pinputtext pKeyFilter="money" [(ngModel)]="ingredient.iron.value"
              [ngModelOptions]="{standalone: true}" type="text" placeholder="Iron" />
            <span class="input-group-addon">mg</span>
          </div>
        </div>
        <div class="form-group col-md-2">
          <label for="lname">Zinc:</label>
          <div class="input-group">
            <input class="form-control" pinputtext pKeyFilter="money" [(ngModel)]="ingredient.zinc.value"
              [ngModelOptions]="{standalone: true}" type="text" placeholder="Zinc" />
            <span class="input-group-addon">mg</span>
          </div>
        </div>
        <div class="form-group col-md-2">
          <label for="lname">Potassium:</label>
          <div class="input-group">
            <input class="form-control" pinputtext pKeyFilter="money" [(ngModel)]="ingredient.potassium.value"
              [ngModelOptions]="{standalone: true}" type="text" placeholder="Potassium" />
            <span class="input-group-addon">mg</span>
          </div>
        </div>
        <div class="form-group col-md-2">
          <label for="lname">Sodium:</label>
          <div class="input-group">
            <input class="form-control" pinputtext pKeyFilter="money" [(ngModel)]="ingredient.sodium.value"
              [ngModelOptions]="{standalone: true}" type="text" placeholder="Sodium" />
            <span class="input-group-addon">mg</span>
          </div>
        </div>
        <div class="form-group col-md-2">
          <label for="lname">Vitamin A:</label>
          <div class="input-group">
            <input class="form-control" pinputtext pKeyFilter="money" [(ngModel)]="ingredient.vitaminA.value"
              [ngModelOptions]="{standalone: true}" type="text" placeholder="Vitamin A" />
            <span class="input-group-addon">mcg</span>
          </div>
        </div>
        <div class="form-group col-md-2">
          <label for="lname">Vitamin C:</label>
          <div class="input-group">
            <input class="form-control" pinputtext pKeyFilter="money" [(ngModel)]="ingredient.VitaminC.value"
              [ngModelOptions]="{standalone: true}" type="text" placeholder="Vitamin C" />
            <span class="input-group-addon">mg</span>
          </div>
        </div>
        <div class="form-group col-md-2">
          <label for="lname">Omega 3:</label>
          <div class="input-group">
            <input class="form-control" pinputtext pKeyFilter="money" [(ngModel)]="ingredient.Omega3.value"
              [ngModelOptions]="{standalone: true}" type="text" placeholder="Omega 3" />
            <span class="input-group-addon">mg</span>
          </div>
        </div>

        <div class="form-group col-md-12">
          <button type="submit" class="btn btn-primary">Add Ingredient</button>
        </div>

      </div>
    </form>
  </div>
</p-dialog>